import { useRouter } from 'next/router';
import { memo } from 'react';

import { LibraryTopBarAddButton } from '~/_app/(library)/l/_components/LibraryTopBarAddButton';
import { GeneralLibraryTopBarAddButton } from '~/_app/(library)/l/general/_components/GeneralLibraryTopBarAddButton';
import { useLibrary } from '~/components/LibraryBeta/hooks/queries/useLibrary';
import { PrivateWorkspaceAgentHeaderTasksButton } from '~/components/v2/components/workspace/workspace-agent-panel/components/entry/PrivateWorkspaceAgentHeaderTasksButton';
import { Routes } from '~/constants/routes';
import { useFetchObjectsPermissions } from '~/hooks/useFetchObjectsPermissions';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';
import { useURLLibraryIdSelector } from '~/hooks/useURLLibraryIdSelector';

const LibraryCreateAction = memo(() => {
  const libraryId = useURLLibraryIdSelector();
  const { data: library } = useLibrary({ libraryId });
  const { pathname } = useRouter();
  const isGeneralLibrary = pathname === Routes.generalLibrary;

  useFetchObjectsPermissions({
    objects: {
      libraryIds: libraryId ? [libraryId] : [],
    },
  });

  if (isGeneralLibrary) {
    return <GeneralLibraryTopBarAddButton />;
  }

  if (!libraryId || !library) {
    return null;
  }

  return <LibraryTopBarAddButton library={library} />;
});

LibraryCreateAction.displayName = 'LibraryCreateAction';

export const LibraryActions = memo(() => {
  const { ui2026 } = useTemporaryFeatureFlags();

  return (
    <>
      <LibraryCreateAction />
      {ui2026 ? <PrivateWorkspaceAgentHeaderTasksButton /> : null}
    </>
  );
});

LibraryActions.displayName = 'LibraryActions';
